import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const action = createActions({
  API_KEY: {
    GET_BUSINESS_KEYS: undefined,
    API: {
      GET_BUSINESS_KEYS: apiResourceActionCreator('keys')
    }
  }
})

export const apiAction = (authToken) => commonApiActions.authenticated.get(`${API_ENDPOINT}/business-keys`, authToken, action.apiKey.api.getBusinessKeys)

function* getBusinessKeys(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken));
}

const configuration = {
  name: 'getBusinessKeys',
  action: action,
  sagas: getBusinessKeys,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetching: true
    }),
    success: (state, action) => ({
      ...state,
      isFetching: false,
      keys: action.payload.keys
    }),
    failed: (state, action) => ({
      ...state,
      isFetching: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/api-key/configurations/getBusinessKeys.js